import { FC, SVGAttributes } from 'react';

const Payco: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_4866_10556)">
        <rect width="36" height="36" fill="white" />
        <path
          d="M20.0419 18.0966V18.0741C20.0419 15.835 21.7293 14 24.1497 14C25.3318 14 26.1306 14.3144 26.7834 14.7988C26.9631 14.9335 27.1203 15.1805 27.1203 15.4853C27.1203 15.9585 26.7385 16.329 26.2654 16.329C26.0296 16.329 25.8724 16.2392 25.7473 16.1606C25.2629 15.7997 24.7576 15.5976 24.1385 15.5976C22.8104 15.5976 21.8544 16.7011 21.8544 18.0501V18.0725C21.8544 19.4231 22.7879 20.5475 24.1385 20.5475C24.8699 20.5475 25.3543 20.3229 25.8483 19.9284C25.9831 19.8161 26.1627 19.7375 26.3664 19.7375C26.8059 19.7375 27.1764 20.0984 27.1764 20.5363C27.1764 20.8057 27.0417 21.0207 26.8845 21.1554C26.1755 21.7745 25.3431 22.1451 24.0823 22.1451C21.763 22.1467 20.0419 20.3582 20.0419 18.0966Z"
          fill="#E7231E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.95886 20.8988L8.70489 14.6977C8.89577 14.2695 9.24544 14.0112 9.71701 14.0112H9.81806C10.2912 14.0112 10.6281 14.2695 10.819 14.6977L13.565 20.8988C13.6211 21.0223 13.6548 21.1346 13.6548 21.2468C13.6548 21.7088 13.2939 22.0793 12.8336 22.0793C12.4278 22.0793 12.1583 21.8435 12.0011 21.4826L11.4718 20.2443H8.00555L7.45378 21.5388C7.30781 21.8756 7.01428 22.0793 6.65499 22.0793C6.20427 22.0793 5.8562 21.7184 5.8562 21.2693C5.8562 21.1458 5.90272 21.0223 5.95886 20.8988ZM10.8302 18.7157L9.73947 16.1157L8.64715 18.7157H10.8302Z"
          fill="#E7231E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 14.9335C0 14.4491 0.383354 14.0674 0.866156 14.0674H3.21761C5.09749 14.0674 6.23311 15.1806 6.23311 16.791V16.8134C6.23311 18.6372 4.81518 19.5819 3.04919 19.5819H1.73231V21.2132C1.73231 21.6976 1.34896 22.0793 0.866156 22.0793C0.38175 22.0793 0 21.696 0 21.2132V14.9335ZM3.10693 18.0405C3.97309 18.0405 4.47995 17.5224 4.47995 16.8471V16.8246C4.47995 16.0483 3.93941 15.6313 3.07325 15.6313H1.73392V18.0389H3.10693V18.0405Z"
          fill="#E7231E"
        />
        <path
          d="M12.9459 15.519L15.4882 18.974H15.4914V21.2132C15.4914 21.696 15.8732 22.0793 16.3576 22.0793C16.8404 22.0793 17.2237 21.6976 17.2237 21.2132V18.9403L19.766 15.5078C19.8783 15.3506 19.9906 15.1356 19.9906 14.8999C19.9906 14.4267 19.6762 14.0562 19.1469 14.0562C18.7876 14.0562 18.5278 14.2599 18.3144 14.5742L16.3672 17.354L14.4536 14.5967C14.2403 14.2807 13.9933 14.0674 13.5987 14.0674C13.1159 14.0674 12.7325 14.4379 12.7325 14.8999C12.7325 15.1469 12.8224 15.3506 12.9459 15.519Z"
          fill="#E7231E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.6272 18.0741V18.0966C27.6272 20.3358 29.3723 22.1467 31.8024 22.1467C34.234 22.1467 36 20.3117 36 18.0725V18.0501C36 15.8109 34.2549 14 31.8248 14C29.3932 14 27.6272 15.835 27.6272 18.0741ZM34.1875 18.0741V18.0966C34.1875 19.4472 33.2203 20.5491 31.8248 20.5491C30.4294 20.5491 29.4397 19.4247 29.4397 18.0741V18.0517C29.4397 16.7027 30.4069 15.5992 31.8024 15.5992C33.1979 15.5992 34.1875 16.7236 34.1875 18.0741Z"
          fill="#E7231E"
        />
      </g>
      <defs>
        <clipPath id="clip0_4866_10556">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Payco;
